export enum Roles {
  Magasin      = 'Magasin',
  StoreManager = 'StoreManager',
  Impersonate  = 'Impersonate'
}